import { render, staticRenderFns } from "./ticketopen.vue?vue&type=template&id=8bc2e4ae&scoped=true"
import script from "./ticketopen.vue?vue&type=script&lang=js"
export * from "./ticketopen.vue?vue&type=script&lang=js"
import style0 from "./ticketopen.vue?vue&type=style&index=0&id=8bc2e4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc2e4ae",
  null
  
)

export default component.exports